/**
 * @component
 * @param {Object} props - The props for the component.
 * @param {string} [props.children]
 */
export default function BoldText({ children = '' }) {
  return <span style={{ fontWeight: 'bold' }}>{children}</span>
}
